import { DraftBasketType, RemoveOrderAction } from '../types';

export const removeOrderToBasket = (state: DraftBasketType, action: RemoveOrderAction): DraftBasketType => ({
  ...state,
  basket: state.basket.filter((item) => item.basketId !== action.payload.id),
});
